import React from 'react';
import { Dialog, DialogContent, Box, TextField, Tooltip, IconButton, Paper, Typography, useTheme, useMediaQuery } from '@mui/material';
import type { GeoJsonFeature } from '../../utils/ogc';
import { DataGrid, type GridColDef, type GridColumnVisibilityModel, type GridRowParams, type GridSortModel } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { format } from 'date-fns';
import { depthToColor } from '../../utils/layer_style';
import RecentlyFloodedStrip from './RecentlyFlooded';
import SensorList from './SensorList';


export const SensorListModalAndButton = React.memo(({ features, currentTime, open, setOpen, onSelect }: { features?: GeoJsonFeature[] | null; currentTime?: Date; open: boolean; setOpen: (open: boolean) => void; onSelect?: (f: GeoJsonFeature) => void }) => {
  const doOpen = React.useCallback(() => setOpen(true), [setOpen]);
  const doClose = React.useCallback(() => setOpen(false), [setOpen]);
  return (<>
    <Tooltip title="Browse sensors">
      <IconButton color="default" onClick={doOpen}>
        <FormatListBulletedIcon />
      </IconButton>
    </Tooltip>
    <SensorListModal open={open} onClose={doClose} features={features} currentTime={currentTime} onSelect={onSelect} />
  </>)
})

export default function SensorListModal({ open, onClose, features, currentTime, onSelect }: { open: boolean; onClose: () => void; features?: GeoJsonFeature[] | null; currentTime?: Date; onSelect?: (f: GeoJsonFeature) => void }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const selectAndClose = React.useCallback((f: GeoJsonFeature) => {
    onSelect?.(f);
    onClose();
  }, [onSelect, onClose]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isSmall}
      maxWidth="md"
      sx={{ '& .MuiDialog-paper': { bgcolor: 'background.paper', p: 0 } }}
    >
      <DialogContent dividers sx={{ p: { xs: 1, sm: 2 }, position: 'relative' }}>
        <IconButton aria-label="Close" onClick={onClose} size="small" sx={{ position: 'absolute', top: 6, right: 6 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
        {/* <RecentlyFloodedStrip features={features || []} onSelect={selectAndClose} /> */}
        <SensorList features={features || []} currentTime={currentTime} onSelect={selectAndClose} />
      </DialogContent>
    </Dialog>
  );
}
